import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { Chapter } from 'common/api/models/Chapter';
import { FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';

interface FormChapterIdSelectProps {
  appState: AppState;
  form: FormikProps<any>;
}
export class FormChapterIdSelectAdmin extends React.Component<FormChapterIdSelectProps> {
  render() {
    let chapters: Chapter[] = [];
    for (let k in this.props.appState.entities.chapter) {
      if (this.props.appState.entities.chapter.hasOwnProperty(k)) {
        chapters.push(this.props.appState.entities.chapter[k]);
      }
    }
    return (
      <FormInput id="chapterAdmin" label="Chapter Admin" tag="select" name="chapterAdmin" autoComplete="off">
        <option value="">None/Foreign</option>
        {chapters.map(c => (
          <option key={c.id} value={c.id}>
            {c.region}: {c.name}
          </option>
        ))}
      </FormInput>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormChapterIdSelectAdmin.tsx